import { Link } from 'react-router-dom';
import { Button } from '~/shared/ui';

/**
 * A missing listing, installation or URL.
 *
 * Kept generic on purpose: a 404 for an unpublished draft must not confirm that the draft exists.
 */
export function NotFoundPage(): JSX.Element {
  return (
    <div className="mx-auto max-w-md py-16 text-center">
      <p className="text-sm font-medium text-brand-soft">404</p>
      <h1 className="mt-2 text-2xl font-semibold tracking-tight text-slate-50">
        That page is not here
      </h1>
      <p className="mt-3 text-sm text-slate-400">
        The address may be mistyped, or the application may no longer be listed.
      </p>
      <div className="mt-6 flex justify-center gap-3">
        <Link to="/applications">
          <Button variant="primary">Browse applications</Button>
        </Link>
        <Link to="/">
          <Button variant="ghost">Go home</Button>
        </Link>
      </div>
    </div>
  );
}
